import { useQuery } from "@tanstack/react-query";
import API from "../../api/api";

const callApi = async (endpoint) => {
    try {
        const response = await API.get(endpoint);
        if (response.status === 200) {
            return response?.data?.data;
        } else {
            return response?.data?.data;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const IDCardService = {
  
    useGetIdCard: () => {
        return useQuery({
            queryKey: ["get-id-card"],
            queryFn: () => callApi("get-id-card"),
        });
    },
   
};